// Translation outside React (e.g. AuthContext, which sits above LanguageProvider).
// Reads the persisted choice directly; no profile lookup.
import { translate, resolveInitialLang } from './translate';
import it from '../locales/it.json';
import en from '../locales/en.json';

const DICTS = { it, en };

const readStored = () => { try { return localStorage.getItem('sg.lang'); } catch (e) { return null; } };

export const tStatic = (key, vars) => translate(DICTS,
  resolveInitialLang({ storedLang: readStored(), navigatorLangs: typeof navigator !== 'undefined' ? navigator.languages : [] }),
  key, vars);
